<template>
  <div class="measure-wrap multi_value_measure">
    <el-form :inline="true" class="measure-form">
      <el-form-item v-for="(vm, index) in valuelist" :key="vm.propValueId + '-' + index">
        <el-select
          filterable
          remote
          :remote-method="getList"
          :loading="loading"
          v-model="vm.propValueId"
          @change="onSelectChange(vm)"
          style="width: 120px"
        >
          <el-option v-for="ops in options" :key="ops.propValueId" :label="ops.propValue" :value="ops.propValueId" />
        </el-select>
        <el-input-digit v-if="vm.needContentNumber || true" v-model.number="vm.content" :precision="2" :max="100" :min="0" style="width: 80px;margin-left: 4px;;">
          <span> % </span>
        </el-input-digit>
        <i class="el-icon-delete" style="cursor: pointer" @click="deleteItem(index)"></i>
      </el-form-item>
      <!-- <MaterialAutoParse @confirm="confirmMaterial" /> -->
      <el-button @click="addItem()" style="margin-left: 10px"> + 添加材质</el-button>
    </el-form>
  </div>
</template>

<script>
import MaterialAutoParse from '@/components/prod/center/BasicComps/MaterialAutoParse.vue';
import { cloneDeep, isEqual } from 'lodash';

import { getCategoryPropsValue } from '@/servers/prod/center/kuaishou.js';
export default {
  components: {
    MaterialAutoParse,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      required: true,
    },
    propId: {
      require: true,
    },
    propName: {
      require: true,
    },
    categoryId: {
      require: true,
    },
  },
  data() {
    return {
      valuelist: [],
      options: [],
      loading: false,
    };
  },
  watch: {
    value: {
      handler(val) {
        const newVal = Array.isArray(val) ? val : [];
        const format = list =>
          list.map(item => ({
            propValueId: item.propValueId,
            propValue: item.propValue,
            content: item.content,
          }));

        if (isEqual(format(newVal), format(this.valuelist))) {
          return;
        }

        this.valuelist = newVal.map(item => {
          return {
            propValueId: item.propValueId || '',
            propValue: item.propValue || '',
            needContentNumber: !!item.content,
            content: item.content || '',
          };
        });
      },
      immediate: true,
      deep: false,
    },
    valuelist: {
      handler(list) {
        // const out = list.map(it => {
        //   return {
        //     propValueId: it.propValueId,
        //     propValue: it.propValue,
        //     content: it.content,
        //   };
        // });
        this.$emit('change', list);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    addItem(item = {}) {
      let newItem = {
        propId: this.propId,
        propValueName: this.propName,
        propValue: item.propValue || '',
        propValueId: item.propValueId || '',
        needContentNumber: item.needContentNumber || false,
        content: item.content !== undefined ? item.content : '',
      };
      this.valuelist.push(newItem);
    },
    deleteItem(index) {
      this.valuelist.splice(index, 1);
    },
    confirmMaterial(parsedList) {
      parsedList.forEach(item => {
        this.addItem(item);
      });
    },
    onSelectChange(vm) {
      const found = this.options.find(o => o.propValueId === vm.propValueId);
      if (found) {
        vm.propValue = found.propValue || '';
        vm.needContentNumber = !!found.needContentNumber;
      }
    },
    async getList(query = '') {
      this.loading = true;
      let res = await getCategoryPropsValue({
        propValue: query,
        page: 1,
        categoryId: this.categoryId,
        propId: this.propId,
      });
      this.options =
        res && res.propValues
          ? res.propValues.map(item => {
              return {
                ...item,
                propId: this.propId,
                propValueName: this.propName,
              };
            })
          : [];
      this.loading = false;
    },
  },

  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.multi_value_measure {
  .measure-form {
    padding: 10px;
    border: 1px solid #ccc;
  }

  .suffix-wrap {
    display: inline-block;
    ::v-deep .el-select .el-input__inner {
      border-left: none;
    }
  }
  .measure-form .el-form-item {
    margin-right: 20px;
    margin-bottom: 10px;
  }
}
</style>
